
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.75 13.5H1.728a.978.978 0 0 1-.978-.978V6.456A1.956 1.956 0 0 1 2.706 4.5h18.587a1.957 1.957 0 0 1 1.957 1.956v6.066a.978.978 0 0 1-.978.978H14.25m2.25-9h-9v-.938a2.911 2.911 0 0 1 3-2.812h3a2.91 2.91 0 0 1 3 2.812Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M10.5 10.5a.75.75 0 0 0-.75.75v2.25a2.25 2.25 0 0 0 4.5 0v-2.25a.75.75 0 0 0-.75-.75Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m21.75 13.5 1.234 8.022A1.5 1.5 0 0 1 21.5 23.25h-19a1.5 1.5 0 0 1-1.482-1.728L2.25 13.5","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    